import React from "react";
import { MapContainer, TileLayer } from "react-leaflet";
import "leaflet/dist/leaflet.css";

const FullMap = () => {
    const handleRedirect = () => {
        window.open("https://www.google.com/maps?q=51.6553,-0.3955", "_blank");    }
  return (
   
    <div style={{ height: "70vh", position: "relative", zIndex: 1 }} className="mt-12">
      <MapContainer
center={[51.6553, -0.3955]} // Watford, London
zoom={13}
        scrollWheelZoom={true}
        style={{ height: "100%", width: "100%" }}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        />
        <button
        onClick={handleRedirect}
        style={{
          position: "absolute",
          top: "10px",
          right: "10px", 
          color: "white",
          padding: "10px 15px",
          borderRadius: "5px",
          border: "none",
          cursor: "pointer",
          zIndex: 1000, 
        }} className="bg-dark"
      >
        Open in Google Maps
      </button>
      </MapContainer>
    </div>
  );
};

export default FullMap;
